module.exports = {
        srcSet: "/_next/static/images/paolo-garri-240.f5bd2ec0.webp"+" 240w",
        images: [{path: "/_next/static/images/paolo-garri-240.f5bd2ec0.webp",width: 240,height: 240}],
        src: "/_next/static/images/paolo-garri-240.f5bd2ec0.webp",
        toString: function(){return "/_next/static/images/paolo-garri-240.f5bd2ec0.webp"},
        
        width: 240,
        height: 240
      }